import { Col, SelectField } from '@/components';
import { isBefore2025 as isBefore2025Func } from '@/features/project/review-sheet/utils/project';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import {
  FundSheetTypeBefore2025LabelModifier,
  FundSheetTypeLabelModifier,
  fundSheetTypeEnum,
} from '@/utils/enum';
import { type FC, memo, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

export const FundSheetTypeColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });

  const fiscalYear = useWatch({
    control,
    name: 'fiscalYear',
  });

  const options = useMemo(() => {
    const isBefore2025 = isBefore2025Func(
      fiscalYear ? { fiscalYear: fiscalYear.year() } : undefined,
    );
    return fundSheetTypeEnum.options.map((value) => ({
      value,
      label: isBefore2025
        ? FundSheetTypeBefore2025LabelModifier[value]
        : FundSheetTypeLabelModifier[value],
    }));
  }, [fiscalYear]);

  if (sheetType !== 'KS') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="fundSheetType"
        label={t('fund-sheet-type')}
        control={control}
        errors={errors}
        allowClear={false}
        shouldCoexistOnChange
        onChange={(v) => {
          const value = v as z.infer<typeof fundSheetTypeEnum>;
          if (value === 'local-government') {
            setValue('period', null);
          }
        }}
        options={options}
      />
    </Col>
  );
});
